// extracted by mini-css-extract-plugin
module.exports = {"constructor":"constructor__7vXkpoK-2gKbn","result":"result__8-vp6YQO+lfOy","letterSettings":"letterSettings__7TD7l3VN-6Sv5"};